import { createSlice } from '@reduxjs/toolkit';

export const WebSocketReducer = createSlice({
  name: 'websocket',
  initialState: {
    connections: {},  // roomId를 키로 사용하는 객체
    activeConnection: null, // 현재 활성 연결의 roomId
    connectionStatus: {}, // roomId별 연결 상태
    subscribedChannels: {}, // roomId별 구독 채널
    messages: {},  // roomId별 메시지 저장
    errors: {}     // roomId별 오류 저장
  },
  reducers: {
    connectStart(state, action) {
      const { roomId } = action.payload;
      state.connectionStatus[roomId] = 'connecting';
    },
    connectSuccess(state, action) {
      const { roomId } = action.payload;
      state.connections[roomId] = true;
      state.connectionStatus[roomId] = 'connected';
      state.activeConnection = roomId;
    },
    connectFail(state, action) {
      const { roomId, error } = action.payload;
      state.connectionStatus[roomId] = 'failed';
      state.errors[roomId] = error;
    },
    disconnectStart(state, action) {
      const { roomId } = action.payload;
      state.connectionStatus[roomId] = 'disconnecting';
    },
    disconnectSuccess(state, action) {
      const { roomId } = action.payload;
      state.connections[roomId] = false;
      state.connectionStatus[roomId] = 'disconnected';
      if (state.activeConnection === roomId) {
        state.activeConnection = null;
      }
    },
    subscribeChannel(state, action) {
      const { roomId, channel } = action.payload;
      if (!state.subscribedChannels[roomId]) {
        state.subscribedChannels[roomId] = [];
      }
      state.subscribedChannels[roomId].push(channel);
    },
    unsubscribeChannel(state, action) {
      const { roomId, channel } = action.payload;
      if (state.subscribedChannels[roomId]) {
        state.subscribedChannels[roomId] = state.subscribedChannels[roomId]
          .filter(ch => ch !== channel);
      }
    },
    messageReceived(state, action) {
      const { roomId, message } = action.payload;
      if (!state.messages[roomId]) {
        state.messages[roomId] = [];
      }
      state.messages[roomId].push(message);
    },
    clearMessages(state, action) {
      const { roomId } = action.payload;
      state.messages[roomId] = [];
    },
    reset(state) {
      return {
        connections: {},
        activeConnection: null,
        connectionStatus: {},
        subscribedChannels: {},
        messages: {},
        errors: {}
      };
    }
  }
});

export const websocketActions = WebSocketReducer.actions;